import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class EmbedLauncher extends Component {
  constructor(props) {
    super(props);

    const launcherWidth = this.launcherWidthFromLetters()
    window.parent.postMessage({ action: 'resizeLauncher', launcherWidth: launcherWidth }, '*')
  }

  componentDidMount () {
    if (this.props.invalidMapKey) {
      window.parent.postMessage({ action: 'invalidMapKey' }, '*')
    }
  }

  launcherWidthFromLetters = () => {
    const widthFromLetters = this.getTextWidth()
    const launcherPaddingWidth = 66
    const miscalulationBuffer = 20
    const launcherHeight = 51

    if (widthFromLetters === 0) return parseInt(launcherHeight, 10)

    return parseInt(widthFromLetters + launcherPaddingWidth + miscalulationBuffer, 10)
  }

  getTextWidth = () => {
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    context.font = '600 17px Roboto, Helvetica Neue, Helvetica'
    let metrics = context.measureText(this.props.launcherText)
    return metrics.width;
  }

  render() {
    return (
      <div className="closeby-launcher">
        <div className="closeby-launcher-svg-section">
          <svg className="closeby-launcher-svg" width="118px" height="118px" viewBox="0 0 118 118" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none">
              <g transform="translate(-41.000000, -41.000000)" fill="#FFFFFF">
                <path d="M100.129702,41.7639429 C132.311683,41.7639429 158.49546,67.9477202 158.49546,100.129702 C158.49546,132.311683 132.307193,158.49546 100.129702,158.49546 C67.9477202,158.49546 41.7639429,132.311683 41.7639429,100.129702 C41.7639429,67.9477202 67.9522099,41.7639429 100.129702,41.7639429 Z M125.249012,75.8737318 C126.535804,73.0485686 123.630499,70.1432072 120.798099,71.4190874 L64.9265652,96.8200385 C61.9592899,98.1688261 62.4623415,102.528691 65.6592708,103.170276 L86.6634974,107.369745 C87.9940324,107.639502 89.0329433,108.678433 89.2990503,110.005349 L93.4984375,131.013627 C94.1400105,134.214263 98.4997909,134.710034 99.8521978,131.746346 L125.249012,75.8737318 Z"></path>
              </g>
            </g>
          </svg>
        </div>
        <div className="closeby-launcher-text">
          {this.props.launcherText}
        </div>
      </div>
    );
  }
}

EmbedLauncher.propTypes = {
  launcherText: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  invalidMapKey: PropTypes.bool
};
